import { AdminTemplate, MerchantFinancialDocumentsGenerator } from "../../components";

export const MerchantFinancialDocuments = () => {
    return (
        <AdminTemplate
            headerProps={{
                headerTitle: "İşyeri Finansal Rapor Oluşturma",
                hideAddButton: true,
                hideDownloadButton: true,
                hideSearchBar: true,
            }}
            showHeaderTitle={false}>
            <MerchantFinancialDocumentsGenerator />
        </AdminTemplate>
    );
};
